"use client"
import NextLink from 'next/link'
import { usePathname } from 'next/navigation'
import { useTransitionRouter } from 'next-view-transitions'
import { useApp } from '@/context/AppContext'

const onTransitionReady = () => {
  document.documentElement.classList.remove('is-loading');
}

export default function AnimatedLink({ children, href, onClick, label = "", transitionName = "base", ref, ...props }) {
  const { handleRouteChangeStart, isMobile } = useApp()
  const pathname = usePathname()
  const router = useTransitionRouter()

  const handleClick = (e) => {
    if (pathname === href) {
      e.preventDefault()
      return
    }

    if ('startViewTransition' in document) {
      e.preventDefault();

      document.documentElement.setAttribute('data-transition-name', transitionName);

      if (onClick) {
        onClick(e)
      }

      document.documentElement.classList.add('is-loading')
      handleRouteChangeStart(transitionName)

      const delay = isMobile && !['slider-left', 'slide-right'].includes(transitionName) ? 500 : 300

      setTimeout(() => {
        router.push(href, { scroll: true, onTransitionReady })
      }, delay)
    } else {
      if (onClick) {
        onClick(e);
      }
    }
  }

  return (
    <NextLink href={href} onClick={handleClick} ref={ref} {...props} aria-label={label}>
      {children}
    </NextLink>
  )
}
